export default __webpack_public_path__ + "static/media/NovelPro.3f0212ff.png";